import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryItemApprovalListing, FactoryItemApprovalDetailListing } from './Pages';

export const FactoryItemApprovalRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FactoryItemApprovalListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={FactoryItemApprovalDetailListing} /> 
    </Fragment>
)